<template>
  <div>
  <div class="one-row one-row-top">
      <div class="regiter-title-box">
        <span class="reg-sub-title"> {{fixDisplayLabel('subscription_pages_steps_text')}}</span>
        <span class="reg-main-title" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''" >{{$t('landing_page_title')}}</span>
      </div>
      <div class="form-box">
        <form class="form" @submit.prevent="handleSubmit">
          <PricingCard @togglePricingModal="togglePricingModal" />
          <span class="box-subtitle" :class="$i18n.locale === 'ar' ? 'box-subtitle-right' : ''">{{ $t('login_page_box_form_email') }}</span> 
					<TextInputField 
						:modelValue="email || userEmail"
						@update:modelValue="email = $event"
						:field-type="'text'"
						name="email"
						:placeholder="''" 
						:has-error="email_error"
						:is-required-value="true"
					/>
					<span class="box-subtitle" :class="$i18n.locale === 'ar' ? 'box-subtitle-right' : ''">{{ $t('login_page_box_form_password') }}</span>
              <TextInputField 
							:modelValue="password"
							@update:modelValue="password = $event"
							:field-type="'password'"
							name="password"
							:placeholder="''" 
							:has-error="password_error"
							:is-required-value="true"
						/>
          
          <div class="coupon-icon-label tooltip" :class="$i18n.locale === 'ar' ? 'box-subtitle-right box-subtitle-dir-right' : ''">
            <span class="box-subtitle" >{{ $t('register_page_form_coupon') }}</span>
            <img src="../assets/images/info-circle.svg" 
            @click="toggleTooltip"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave">
            <div v-if="showTooltip" class="tooltip-overlay " @click.self="closeTooltip"
            :class="$i18n.locale === 'ar' ? 'rtl-tooltip' : ''">
                <p class="tooltiptext" :class="$i18n.locale === 'ar' ? 'info-text-right tooltiptext-position' : ''">
                  <strong>{{ parsedTooltip.bold }}</strong><br>
                  {{ parsedTooltip.normal }}
                </p>
              </div>
          </div>
          <TextInputField 
						:modelValue="coupon"
						@update:modelValue="coupon = $event"
            :is-disabled="disablePromoBox"
						:field-type="'text'"
						name="coupon"
						:placeholder="''"
						:is-required-value="false"
					/>
          <div class="check-box-wrapper" :class="$i18n.locale === 'ar' ? 'check-box-wrapper-right' : ''">
            <input type="checkbox" v-model="isPromoAccepted" v-if="$i18n.locale !== 'ar'">
            <label :class="$i18n.locale === 'ar' ? 'arabic-text' : ''" >{{ $t('accept_promotional_content') }}</label>
            <input type="checkbox" required v-model="isPromoAccepted" v-if="$i18n.locale === 'ar'">
          </div>

          <div class="check-box-wrapper" :class="$i18n.locale === 'ar' ? 'check-box-wrapper-right' : ''">
            <input type="checkbox" required v-model="isTcAccepted" v-if="$i18n.locale !== 'ar'">
            <label :class="$i18n.locale === 'ar' ? 'arabic-text' : ''"  v-html="$t('accept_terms', { link:'https://www.kidjo.tv/terms'})"></label>
            <input type="checkbox" required v-model="isTcAccepted" v-if="$i18n.locale === 'ar'">
          </div>
          <SubmitButton :label="$t('register_page_form_submit')" :isLoading="loading" />
        </form>
      </div>
  </div>
  <PricingPopup  v-if="showPricingPopup" @togglePricingModal="togglePricingModal"/>

  </div>
</template>
<script>
import partnerOrangeMixin from '@/mixins/orange';
import TextInputField from '../components/TextInputField.vue';
import SubmitButton from '../components/SubmitButton.vue';
import PricingCard from '../components/PricingCard.vue';

// Get EU countries
// import eu_cc from '../eu-cc.js';
import {validateCoupon} from "../services/subscriptions.v2.services";
import { getErrorString } from '../utils/constant.js';
import PricingPopup from '../components/PricingPopup.vue';
import PasswordService from '../services/password.service';

export default {
  components: { 
			"TextInputField": TextInputField,
			"SubmitButton": SubmitButton,
      "PricingCard": PricingCard,
      "PricingPopup": PricingPopup
    },
  mixins: [partnerOrangeMixin],
  data() {
    return {
      showPricingPopup: false,
      showTooltip: false,
      name: '',
      email: '',
      email_error: false,
      password: '',
      password_error: false,
      coupon: '',
      isPromoAccepted: false,
      isTcAccepted: false,
      loading: false,
      swissComeCampaign: false,
      disablePromoBox: false,
      discountPromoApplied: false,
      couponDurationCode: '',
      discountPrice: '',
    }
  },
  computed: {
    userEmail: function() {
      return this.$store.getters.getCurrentAccountEmail;
    },
    parsedTooltip: function() {
      const match = this.$t('registration_coupons_tooltip').match(/<b>(.*?)<\/b>([\s\S]*)/);
      if (match) {
        console.log('match', match);
        return {
          bold: match[1].trim(),
          normal: match[2].trim()
        };
      }
      return {
        bold: '',
        normal: this.$t('registration_coupons_tooltip')
      };
  }
  },

  methods: {
    isDesktop() {
      return window.innerWidth > 768; // adjust threshold as needed
    },
    handleMouseEnter() {
      if (this.isDesktop()) {
        this.showTooltip = true;
      }
    },
    handleMouseLeave() {
      if (this.isDesktop()) {
        this.showTooltip = false;
      }
    },
    toggleTooltip() {
      if (!this.isDesktop()) {
        this.showTooltip = !this.showTooltip;
      }
    },
    closeTooltip() {
      this.showTooltip = false;
    },
    fixDisplayLabel(label) {
      return this.$t(label, {step: 1});
    },
    togglePricingModal() {
      this.showPricingPopup = !this.showPricingPopup;
    },
    handleSubmit: async function () {
      this.loading = true;
      var has_error = this.checkFields();
      var coupon = (this.swissComeCampaign ? 'YAJKM0' : this.coupon);
      if (!has_error) {
        var hesh = PasswordService.SHA256(this.password);
        var data = {
          'email': this.email,
          'password': hesh,
          'displayName': this.name,
          'coupon': coupon,
          'isPromoAccepted' : this.isPromoAccepted,
          'isTcAccepted' : this.isTcAccepted,
          'env': "web",
          'countryCode': this.$parent.countryCode
        };
        const registered = await this.$store.dispatch('registerUser', data);
        this.loading = false;
        if (registered.status !== true) {
          return this.handleError(registered);
        }
        if (registered.freeCampaign === true) {
          this.removeCouponFromStorage();
          return this.$router.push('/products').catch(() => {
          });
        }
        this.$router.push('/subscribe').catch(() => {
        });
      }
    },

    handleError: function (response) {
      return this.$parent.showFlashMessage(this.$t(getErrorString(response.status, response?.data?.code)));
    },

    checkFields: function () {
      var has_error = false;

      // if (this.name === '') {
      //   this.name_error = true;
      //   has_error = true;
      // }

      if (this.email === '') {
        this.email_error = true;
        has_error = true;
      }

      if (this.password === '') {
        this.password_error = true;
        has_error = true;
      }

      return has_error;
    },

    setMobileLayout() {
      var slider = document.getElementById('slider');
      var form = document.getElementById('form');

      // form.style.display = 'block';
      // slider.style.display = 'none';

      if (window.innerWidth <= 340) {
        window.scrollTo(0, 30);
      }
    },

    removeCouponFromStorage: function () {
      localStorage.removeItem('coupon');
      localStorage.removeItem('couponDurationCode');
    },

    checkForSwisscom: function () {
      if (this.$route.name === 'swisscom') {
        this.swissComeCampaign = true;
      } else {
        localStorage.removeItem('swissComeCampaign');
      }
    },

    getCouponDuration: function () {
      const duration_period = {
        day: this.$t('label_day'),
        days: this.$t('label_days'),
        month: this.$t('month'),
        months: this.$t('label_months'),
      };

      const value = this.couponDurationCode;

      const duration = value.replace(/\D/g, '');
      let suffix = 'month';

      if (value.includes('D')) {
        suffix = 'day';
      }

      if (duration !== '1') {
        suffix += 's';
      }

      return {
        duration,
        "durationPeriods": duration_period[suffix],
        "durationPeriod": duration_period[suffix.slice(0, -1)]
      };
    }
  },

  mounted: function () {
    if (this.userEmail) {
      this.email = this.userEmail;
    }
    if (this.$route.params['code'] != null) {
      this.coupon = this.$route.params['code'].toUpperCase();
      this.disablePromoBox = true;
      validateCoupon(this.coupon).then((response) => {
        const couponDetails = response.data;
        localStorage.setItem("coupon", this.coupon);
        this.couponDurationCode = couponDetails?.couponDurationCode
        localStorage.setItem("couponDurationCode", this.couponDurationCode);
        localStorage.setItem("discountDetails", JSON.stringify(couponDetails?.discountDetails));
        this.discountPromoApplied = true;
        this.discountPrice = couponDetails?.discountDetails.discountPrice;
      }).catch((error) => {
        this.$parent.showFlashMessage(this.$t('error_message_coupon_invalid'));
        this.coupon = '';
        this.$router.push({name: 'register'});
      })
    }
    // If the user is from vewl platform go to login
    if (this.$parent.tvPlatform === true) {
      this.$router.push({name: 'login'}).catch(() => {
      });
    }

    if (this.$store.getters.getToken !== false) {
      if (this.$store.getters.getPremium === false) {
        this.$router.push({name: 'subscribe'}).catch(() => {
        });
      } else {
        this.$router.push({name: 'home'}).catch(() => {
        });
      }
    }

    if (this.$parent.appStyle === 'subscribe') {
      this.$parent.changeAppStyle('profile');
    }

    // Swisscome campaign method
    this.checkForSwisscom();

    if (window.innerWidth <= 1024) {
      this.setMobileLayout();

      setTimeout(function () {
        window.scrollTo(0, 120);
      }, 1000)
    }
    const params = new URLSearchParams(window.location.search);
			if (params.has('email')) {
        this.email = decodeURIComponent(params.get('email'));
        // Remove the email param from the URL without reloading
        params.delete('email');
        const newQuery = params.toString();

        // Update the URL in browser (without reloading)
        const newUrl = newQuery
          ? `${window.location.pathname}?${newQuery}`
          : window.location.pathname;

        window.history.replaceState({}, '', newUrl);
      }
  },
}
</script>

<style lang="sass">
.coupon-icon-label
  display: flex
  flex-direction: row
  gap: 10px
.one-row-top
  margin-top: 10%

.regiter-title-box
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  text-align: center
  padding-inline: 10px

  .reg-main-title
    font-size: 24px
    font-family: "Nunito-ExtraBold"
    color: #020076
    
    @media (orientation: portrait)
      font-size: 18px
      line-height: 1.05
    
  .reg-sub-title
    font-size: 20px
    font-family: "Nunito-Regular"
    color: #020076

    @media (orientation: portrait)
      font-size: 14px
      line-height: 2

.slide-fade-enter-active
  transition: all .3s ease

.slide-fade-leave-active
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0)

.slide-fade-enter, .slide-fade-leave-to
  transform: translateX(10px)
  opacity: 0
.loader
    border: 7px solid #ffac01
    border-left-color: #ffffff
    animation: spin 1s linear infinite
    width: 37px
    height: 37px
    border-radius: 50%
    text-align: center
.loader-container
    display: flex
    justify-content: center
    align-items: center
    position: relative
.loader-section
    top: 50%
    left: 50%
    margin: 15%
    @keyframes spin
      0%
        transform: rotate(0deg)
      100%
        transform: rotate(360deg)
</style>
<style scoped lang="scss">
.coupon-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Nunito', sans-serif;
}

.tooltip {
  position: relative;
}

.tooltip .tooltiptext {
  background-color: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0px 2px 10px rgba(0,0,0,0.1);
  color: #020076;
  position: absolute;
  z-index: 2;
  top: -53px;
  left: 43%;
  font-family: "Nunito-Regular";
  font-size: 16px;
  white-space: normal;
  text-align: left;
  width: max-content;
  max-width: 350px;
}
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 10px;
  border-style: solid;
  border-color: transparent white transparent transparent;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
.tooltip-overlay {
  pointer-events: all;
}
.info-text-right {
  text-align: right !important;
  direction: rtl;
}

.rtl-tooltip .tooltiptext::after {
  left: 100% !important;
  right: auto !important;
  border-color: transparent transparent transparent white;
}
@media (min-width: 1024px) {
  .rtl-tooltip .tooltiptext {
    right: 35% !important;
    left: auto !important;
    text-align: right;
    direction: rtl;
    color: #020076;
  }
  .tooltiptext-position {
    top: -37px !important;
    left: -35% !important;
  }
}
@media screen and (max-width: 768px) {
  .tooltip-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(154, 150, 196, 0.5);
    z-index: 9999;
  
  .tooltiptext {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    z-index: 9999;
    text-align: center;
    border-radius: 14px;
    font-size: 14px;
    width: max-content;
    max-width: 350px;
    color: #020076;
    
    @media (orientation: landscape) {
      max-width: 50%;
    }
  }

  .tooltiptext::after {
    display: none;
  }
}
}
</style>
